import React from 'react';
import ExploreCategoriesSection from './ExploreCategoriesSection';
import RecommendedTracksSection from './RecommendedTracksSection';
import {
  ErrorState,
  LoadingState,
  MeetExpertBanner,
  PageHeader,
  PageShell,
} from './PageChrome';
import useYourQuickRichuels from './useYourQuickRichuels';
import styles from './YourQuickRichuelsPage.module.css';

function YourQuickRichuelsPage() {
  const {
    loading,
    loadError,
    categories,
    contents,
    recommendedContents,
    recommendedCategory,
    handleSelectTrack,
    handleSeeWhatsNext,
    handleGoHome,
    handleMeetExpert,
    handleRetry,
  } = useYourQuickRichuels();

  return (
    <PageShell busy={loading}>
      <div className={styles.mainContent}>
        <PageHeader onSeeWhatsNext={handleSeeWhatsNext} />
        {loading ? (
          <LoadingState />
        ) : loadError ? (
          <ErrorState onRetry={handleRetry} onGoHome={handleGoHome} />
        ) : (
          <>
            <RecommendedTracksSection
              tracks={recommendedContents}
              recommendedCategory={recommendedCategory}
              completedCount={0}
              totalCount={recommendedContents.length}
              onSelectTrack={handleSelectTrack}
              showProgress={false}
              subtitle="Your next best money moves."
            />
            <ExploreCategoriesSection
              categories={categories}
              contents={contents}
              onSelectTrack={handleSelectTrack}
            />
          </>
        )}
        <MeetExpertBanner onMeetExpert={handleMeetExpert} />
      </div>
    </PageShell>
  );
}

export default YourQuickRichuelsPage;
